import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	combo: {
		"& > div": {
			display: "grid",
			gridRowGap: theme.spacing(7),
			padding: 0,
			"& .mco-view-component-container-extension-infobox .extension-infobox-image": {
				display: "none"
			},
			"& > .mco-view-component-container:not(.mco-view-component-container-extension-infobox)":
				{
					padding: 0
				},
			[theme.breakpoints.up("md")]: {
				gridTemplateColumns: "1fr 1fr",
				gridTemplateRows: "auto auto 1fr",
				gridColumnGap: theme.spacing(7),
				gridRowGap: theme.spacing(10),
				"& .mco-view-component-container:not(.mco-view-component-container-extension-infobox)":
					{
						gridColumn: "1 / 2"
					},
				"& .mco-view-component-container-extension-infobox": {
					padding: "0 !important",
					gridColumn: "2 / 3",
					gridRow: "1 / -1",
					marginTop: -150,
					position: "relative",
					zIndex: 1,
					[theme.breakpoints.up("lg")]: {
						marginTop: -200,
						maxWidth: 600
					},
					"& > div": {
						padding: 0
					},
					"& .extension-infobox": {
						background: "#eaedef",
						gridTemplateColumns: "auto",
						padding: theme.spacing(5) + "px !important",
						[theme.breakpoints.up("lg")]: {
							padding: theme.spacing(10) + "px !important"
						},
						"& .extension-infobox-content": {
							left: "auto !important",
							marginLeft: "unset !important"
						}
					},
					"&:before": {
						display: "none"
					}
				}
			},
			[theme.breakpoints.up("lg")]: {
				gridTemplateColumns: "1fr 1.5fr",
				gridColumnGap: theme.spacing(16)
			}
		}
	}
}));

export default styles;
